<template>
  <div>
    <ul class="pagination" v-if="!simpleMode">
      <li class="page-item" :class="{disabled : isFirstPage}"><a class="page-link" @click="changePage(1)">First</a></li>
      <li class="page-item" :class="{disabled : isFirstPage || page === -1}"><a class="page-link" @click="isFirstPage ? changePage(1) : changePage(page-1)">Previous</a></li>

      <li class="page-item" v-for="pageNumber in pageRange" :key="pageNumber" :class="{active : isCurrentPage(pageNumber)}">
        <a class="page-link" @click="changePage(pageNumber)">{{pageNumber}}</a>
      </li>

      <li class="page-item" :class="{disabled : isLastPage || page === -1}"><a class="page-link" @click="isLastPage ?  changePage(totalPages) : changePage(page+1)">Next</a></li>
      <li class="page-item" :class="{disabled : isLastPage}"><a class="page-link" @click="changePage(totalPages)">Last</a></li>
      <li class="page-item" :class="{active : page === -1 }"><a class="page-link" @click="changeAllPage()">All</a></li>
    </ul>
    <div v-if="simpleMode">
      <a v-if="!isFirstPage" @click="changePage(page-1)" href="javascript:void(0)">&lt;&lt;&lt; Previous</a>
      <span v-if="isFirstPage">&lt;&lt;&lt; Previous</span>
      &nbsp;
      &nbsp;
      <span v-if="isLastPage">Next &gt;&gt;&gt;</span>
      <a v-if="!isLastPage" @click="changePage(page+1)" href="javascript:void(0)">Next &gt;&gt;&gt;</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    allData: {
      type: Array
    },
    pageSize: {
      type: Number,
      default: 15
    },
    pageRangeSize: {
      type: Number,
      default: 7
    },
    simpleMode: {
      type: Boolean,
      default: false
    },
    sortData: {
      type: Object
    }
  },

  data: function () {
    return {
      page: 1,
      allDataSorted: null
    }
  },

  methods: {
    changePage (page) {
      this.$emit('setPageData', page === -1 ? this.getAllData() : this.getPageData(page))
      this.page = page
    },

    changeAllPage () {
      this.changePage(-1)
    },

    getPageData (page) {
      return this.getAllData().slice(this.getTopOfPage(page), this.getBottomOfPage(page))
    },

    getAllData () {
      return this.allDataSorted !== null ? this.allDataSorted : this.allData
    },

    getTopOfPage (page) {
      return (page - 1) * this.pageSize
    },

    getBottomOfPage (page) {
      return this.getTopOfPage(page) + this.pageSize
    },

    isCurrentPage (page) {
      return this.page === page
    },

    range (start, end) {
      let result = [start]
      for (let i = start + 1; i <= end; i++) {
        result.push(i)
      }
      return result
    },

    resetAllDataSorted () {
      this.allDataSorted = null
    },

    refreshCurrentPage () {
      this.changePage(this.page > this.totalPages ? this.totalPages : this.page )
    }
  },

  computed: {
    totalPages () {
      if (this.allData == null || this.allData.length === 0) {
        return 1
      }
      return Math.ceil(this.allData.length / this.pageSize)
    },

    isFirstPage () {
      return (this.page === 1)
    },

    isLastPage () {
      return (this.page === this.totalPages)
    },

    pageRange () {
      let pageRangeSize = this.pageRangeSize - 1
      if (this.totalPages <= pageRangeSize) {
        return this.totalPages
      }

      let start = this.page - Math.floor(pageRangeSize / 2)
      let end = this.page + Math.ceil(pageRangeSize / 2)
      if (start < 1) {
        end += Math.abs(start) + 1
        start = 1
      }
      if (end > this.totalPages) {
        start -= end - this.totalPages
        end = this.totalPages
      }
      return this.range(start, end)
    },
  },

  watch: {
    allData: function () {
      this.resetAllDataSorted()
      this.refreshCurrentPage()

      if (this.page === 1 && !this.sortData.loaded) {
        this.changePage(1)
        this.sortData.loaded = true
      }
    },
    sortData: {
      handler () {
        if(this.sortData.counter % 3 === 0){
          this.allDataSorted = this.allData.slice()
        }
        else {
          this.allDataSorted = this.allData.slice().sort((a,b) => {
            let modifier = 1;

            if(this.sortData.type === 'currency'){
              if (a[this.sortData.currentSort] === b[this.sortData.currentSort]) { return 0; }
              if (a[this.sortData.currentSort] === null) {
                return modifier;
              } else if (b[this.sortData.currentSort] === null) {
                return -1 * modifier;
              }
              if(this.sortData.currentSortDir === 'desc') modifier = -1;
              if(parseFloat(a[this.sortData.currentSort].replace('$','')) < parseFloat(b[this.sortData.currentSort].replace('$','')))
                return -1 * modifier;
              if(parseFloat(a[this.sortData.currentSort].replace('$','')) > parseFloat(b[this.sortData.currentSort].replace('$','')))
                return modifier;
            }

            else if(this.sortData.currentSort.includes('.')) {
              let columnName = this.sortData.currentSort.split('.');
              if (a[columnName[0]] === b[columnName[0]]) {
                return 0;
              }
              if (a[columnName[0]] === null) {
                return modifier;
              } else if (b[columnName[0]] === null) {
                return -1 * modifier;
              }
              if (this.sortData.currentSortDir === 'desc')
                modifier = -1;
              if (a[columnName[0]] && typeof a[columnName[0]] !== null && a[columnName[0]] !== 'null' && a[columnName[0]] === 'string') {
                if (a[columnName[0]][columnName[1]].toLowerCase() < b[columnName[0]][columnName[1]].toLowerCase())
                  return -1 * modifier;
                if (a[columnName[0]][columnName[1]].toLowerCase() > b[columnName[0]][columnName[1]].toLowerCase())
                  return modifier;
              } else {
                if (a[columnName[0]] && typeof a[columnName[0]] !== null && a[columnName[0]] !== 'null') {
                  if (a[columnName[0]][columnName[1]] < b[columnName[0]][columnName[1]])
                    return -1 * modifier;
                  if (a[columnName[0]][columnName[1]] > b[columnName[0]][columnName[1]])
                    return modifier;
                }
              }
            }

            else {
              if (a[this.sortData.currentSort] === b[this.sortData.currentSort]) { return 0; }
              if (a[this.sortData.currentSort] === null) {
                return modifier;
              } else if (b[this.sortData.currentSort] === null) {
                return -1 * modifier;
              }
              if (this.sortData.currentSortDir === 'desc')
                modifier = -1;
              if(this.sortData.currentSort === 'string'){
                if (a[this.sortData.currentSort].toLowerCase() < b[this.sortData.currentSort].toLowerCase())
                  return -1 * modifier;
                if (a[this.sortData.currentSort].toLowerCase() > b[this.sortData.currentSort].toLowerCase())
                  return modifier;
              }
              else {
                if(a[this.sortData.currentSort] < b[this.sortData.currentSort])
                  return -1 * modifier;
                if(a[this.sortData.currentSort] > b[this.sortData.currentSort])
                  return modifier;
              }
            }
            return 0;
          });
        }
        this.refreshCurrentPage()
      },
      deep: true
    }
  }
}
</script>
<style>
  .pagination>li {
    display: inline-block!important;
    margin-right: -4px;
  }
  .page-item:first-child .page-link,
  .page-item:last-child .page-link{
    border-radius: 0px;
    cursor: pointer;
  }
  .pagination > li.disabled {
     cursor: not-allowed;
   }
  .pagination > li.disabled> a,.pagination > li.disabled> span {
    pointer-events: none;
  }
  .pagination > li.disabled .page-link{
    color: #908b8b!important;
  }

</style>
